export default __webpack_public_path__ + "static/media/van.e8cb5cfd.png";